import { render, staticRenderFns } from "./TechDataComponent.vue?vue&type=template&id=ef826c6e&"
import script from "./TechDataComponent.vue?vue&type=script&lang=js&"
export * from "./TechDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports